import * as tslib_1 from "tslib";
import { ListBase } from '../../base/list/list.base';
import { NotificationsService } from '../notifications.service';
import { DialogService } from '../../core/dialog.service';
import { AlertsService } from '../../core/alerts.service';
import { TranslateService } from '@ngx-translate/core';
import { Router } from '@angular/router';
import { OverlayService } from '../../core/overlay.service';
import { LocalStorageService } from '../../core/local-storage.service';
import { EventsService } from '../../core/event.service';
import { UserService } from '../../user.service';
import { ActionService } from '../../core/action.service';
/**
 * The NotificationsListComponent is used to show the inbox and outbox list.
 * @export
 * @class NotificationsListComponent
 * @extends {ListBase}
 */
var NotificationsListComponent = /** @class */ (function (_super) {
    tslib_1.__extends(NotificationsListComponent, _super);
    /**
     * Constructs a NotificationsListComponent.
     * @param configurationsService Service to get the configuration of this component.
     * @param domainService Service to load and save entity data.
     * @param dialogService Service for displaying dialogs.
     * @param alertsService Service for publish alerts.
     * @param router Service for routing events.
     * @memberOf NotificationsListComponent
     */
    function NotificationsListComponent(userService, notificationService, dialogService, alertsService, translateService, router, overlayService, localStorageService, eventsService, actionService) {
        var _this = _super.call(this, userService, notificationService, dialogService, alertsService, translateService, router, overlayService, localStorageService, eventsService, actionService) || this;
        /**
         * Property used to determine if expired requests should be shown.
         * @private
         * @memberOf NotificationsListComponent
         */
        _this._showExpired = false;
        _this.notificationsService = notificationService;
        _this.subscriptionPool.add(_this.notificationsService.unreadCountChanged.subscribe(function () {
            _this.refresh();
        }));
        var params = JSON.parse(JSON.stringify(_this.router.routerState.snapshot.root.queryParams).toLowerCase());
        _this._showExpired = params['expired'] == null ? false : params['expired'] === 't';
        return _this;
    }
    Object.defineProperty(NotificationsListComponent.prototype, "showExpired", {
        /**
         * Returns a boolean, whether or not expired requests should be shown.
         * @readonly
         * @type {boolean}
         * @memberOf NotificationsListComponent
         */
        get: function () {
            return this._showExpired;
        },
        /**
         * Sets a value whether or not to show the expired requests.
         * @memberOf NotificationsListComponent
         */
        set: function (value) {
            if (this._showExpired !== value) {
                this._showExpired = value;
                this.refresh();
                var params = JSON.parse(JSON.stringify(this.router.routerState.snapshot.root.queryParams).toLowerCase());
                params['expired'] = value ? 'T' : 'F';
                this.router.navigate([], { queryParams: params });
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NotificationsListComponent.prototype, "isOutbox", {
        /**
         * Determines if the current view is the outbox
         * @readonly
         * @type {boolean}
         * @memberOf NotificationsListComponent
         */
        get: function () {
            if (!this.configuration || !this.configuration.features) {
                return false;
            }
            var outbox = this.configuration.features.find(function (item) { return item === 'Outbox'; });
            return !!outbox;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Method to retrieve the requested entities from the backend api.
     * @returns An Observable object that retrieves the requested entities.
     * @memberOf NotificationsListComponent
     */
    NotificationsListComponent.prototype.refresh = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                return [2 /*return*/, _super.prototype.refresh.call(this)];
            });
        });
    };
    /**
     * Cancels the selected requests in the outbox.
     * @memberOf NotificationsListComponent
     */
    NotificationsListComponent.prototype.withdrawRequests = function () {
        var self = this;
        this.notificationsService.withDrawRequests(this.selectedRequests, function (error) {
            if (!error) {
                self.alertsService.createAlert('success', 'APP.FORMS.ITEMS_SUCCESSFULLY_SAVED');
            }
        }, function () {
            self.refresh();
        });
    };
    /**
     * Marks the selected items as read, in the inbox.
     * @memberOf NotificationsListComponent
     */
    NotificationsListComponent.prototype.setRequestsReadValue = function (value) {
        var self = this;
        this.notificationsService.setRequestsReadValue(this.selectedRequests, value, this.userService.user['Oid'], function (error) {
        }, function () {
            self.refresh();
        });
    };
    Object.defineProperty(NotificationsListComponent.prototype, "selectedRequests", {
        /**
         * Casts the selected items to requests.
         * @readonly
         * @private
         * @type {Request[]}
         * @memberOf NotificationsListComponent
         */
        get: function () {
            return this.selected;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Mark the selected items as accepted, in the inbox.
     * @memberOf NotificationsListComponent
     */
    NotificationsListComponent.prototype.acceptRequests = function () {
        var self = this;
        this.notificationsService.acceptRequests(this.selectedRequests, function (error) {
            if (!error) {
                self.alertsService.createAlert('success', 'APP.FORMS.ITEMS_SUCCESSFULLY_SAVED');
            }
        }, function (value) {
            self.refresh();
        });
    };
    /**
     * Mark the selected items as declined, in the inbox.
     * @memberOf NotificationsListComponent
     */
    NotificationsListComponent.prototype.declineRequests = function () {
        var self = this;
        this.notificationsService.declineRequests(this.selectedRequests, function (error) {
            if (!error) {
                self.alertsService.createAlert('success', 'APP.FORMS.ITEMS_SUCCESSFULLY_SAVED');
            }
        }, function (value) {
            self.refresh();
        });
    };
    /**
     * Return whether or not the item in the table should be displayed as bold.
     * @param {any} item The item represented in the row.
     * @returns true, when the item should be displayed in bold, otherwise false.
     * @memberOf NotificationsListComponent
     */
    NotificationsListComponent.prototype.isBold = function (item) {
        return !item.IsRead;
    };
    /**
     * Checks whether the whole selection can be withdrown.
     * If used to enable or disable withdraw button.
     * @returns {boolean} True when the selection contains no readonly requests.
     * @memberOf NotificationsListComponent
     */
    NotificationsListComponent.prototype.selectionWithdrawable = function () {
        if (this.selected.length === 0) {
            return false;
        }
        var result = this.selected.every(function (item) { return !item.ReadOnly; });
        return result;
    };
    /**
     * Checks whether all of the selected requests can be accepted or declined by the user.
     * @returns {boolean} True if none the selected requests are finalized.
     * @memberOf NotificationsListComponent
     */
    NotificationsListComponent.prototype.selectionNotFinal = function () {
        if (this.selected.length === 0) {
            return false;
        }
        var result = this.selected.every(function (item) { return item.Status === 'REQUEST'; });
        return result;
    };
    /**
     * Returns a value indicating whether any of the selected requests are not read.
     * @memberOf NotificationsListComponent
     */
    NotificationsListComponent.prototype.hasUnreadSelectedItems = function () {
        return this.selectedRequests.some(function (request) {
            return !request.IsRead;
        });
    };
    /**
     * Returns a value indicating whether any of the selected requests are read.
     * @memberOf NotificationsListComponent
     */
    NotificationsListComponent.prototype.hasReadSelectedItems = function () {
        return this.selectedRequests.some(function (request) {
            return request.IsRead;
        });
    };
    return NotificationsListComponent;
}(ListBase));
export { NotificationsListComponent };
